import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageLayoutTabs } from '@thinknet-gmbh/platform-common-ui';

import { useRouteQuery } from 'src/common/helpers';
import { ROUTES } from 'src/components/app/app-routes.constants';

import { SETTINGS_PAGES } from './settings.constants';
import { Company } from './components/company';
import { UserManagement } from './components/user-management';
import { CompanySettings } from './components/company-settings';
import { PermissionGroup } from './components/permission-group';
import { EditPermissionGroup } from './components/permission-group/components/edit-permission-group';
import { UserProfile } from './components/user-profile';
import { HolidayManager } from './components/holiday-manager';
import { HolidayDetails } from './components/holiday-manager/components/holiday-details';
import Interfaces from './components/interfaces/interfaces.component';

const Settings: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const query = useRouteQuery();
  const type: string = query.get('type') || '';
  const isHolidayPage: string = query.get('page') || '';

  return (
    <PageLayoutTabs
      pageTitle={t('labels.settings')}
      onTabChange={activeKey => navigate(`${ROUTES.settings}?type=${activeKey}`)}
      defaultTab={
        type === SETTINGS_PAGES.permissionGroupsEdit ? SETTINGS_PAGES.permissionGroups : type
      }
      elements={[
        {
          tab: t('labels.company'),
          tabIndex: SETTINGS_PAGES.company,
          component: <Company />,
        },
        {
          tab: t('labels.companySettings'),
          tabIndex: SETTINGS_PAGES.companySettings,
          component: <CompanySettings />,
        },
        {
          tab: t('labels.userManagement'),
          tabIndex: SETTINGS_PAGES.userManagement,
          component: <UserManagement />,
        },
        {
          tab: t('labels.permissionGroups'),
          tabIndex: SETTINGS_PAGES.permissionGroups,
          component:
            type === SETTINGS_PAGES.permissionGroupsEdit ? (
              <EditPermissionGroup />
            ) : (
              <PermissionGroup />
            ),
        },
        {
          tab: t('labels.userProfile'),
          tabIndex: SETTINGS_PAGES.userProfile,
          component: <UserProfile />,
        },
        {
          tab: t('labels.holidayManager'),
          tabIndex: SETTINGS_PAGES.holidayManager,
          component: !isHolidayPage ? <HolidayManager /> : <HolidayDetails />,
        },
        {
          tab: t('labels.interfaces'),
          tabIndex: SETTINGS_PAGES.interfaces,
          component: <Interfaces />,
        },
      ]}
    />
  );
};

export default Settings;
